/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    framedContainerBackgroundColor: '#fafafa',
    framedContainerBorderColor: '#c9c8c8',
    framedContainerBorderRadius: 4,
    framedContainerBorderWidth: 1,
    framedContainerPadding: 24,
    framedMaxHeight: 640,
    stackViewDividerColor: '#c9c8c8'
  }
}
export default theme
